import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { runInAction } from 'mobx'
import { useHistory } from 'react-router-dom'
import PageTitle from '../../components/PageTitle'
import DashboardLayout from '../../layouts/DashboardLayout'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import { Button, Form, Select, Space, Tag, Tooltip, message } from 'antd'
import { BankOutlined, TeamOutlined, UserOutlined } from '@ant-design/icons'
import {
  ASSIGNEE_TYPE,
  DOCUMENT_ACCESS_TYPE,
  DOCUMENT_TYPE,
} from '../../constants'
import SelectPeoplePopup from '../../components/SelectPeoplePopup'
import { AvatarHasName } from '../../components/Common/Avatar'
import { blue } from '../../color'
import { FormButtonGroup, SelectList } from './WorkStyledPage'

const RiskManagement = props => {
  const {
    selectPeopleStore,
    documentAccessibilityStore,
    authenticationStore,
    loadingAnimationStore,
  } = props
  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const [form] = Form.useForm()

  const formStyle = {
    paddingLeft: '16px',
  }

  const formItemStyle = {
    width: '300px',
  }

  const labelStyle = {
    display: 'inline-block',
    margin: '15px 8px 25px 0',
  }

  const [followerList, setFollowerList] = useState([])
  const [accessType, setAccessType] = useState()
  const [docAccess, setDocAccess] = useState([])

  useEffect(() => {
    return () => {
      selectPeopleStore.clearSelected()
      runInAction(() => {
        documentAccessibilityStore.documentAccessibilities = []
      })
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      if (!accessType) return
      try {
        selectPeopleStore.clearSelected()
        loadingAnimationStore.showSpinner(true)
        const response = await documentAccessibilityStore.getDocumentAccessibilities(
          'WORKS',
          'VIEW_ALL'
        )
        setDocAccess(response.data)
      } catch (error) {
        message.error(error.vi)
        console.log(error)
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [accessType])

  useEffect(() => {
    documentAccessibilityStore.documentAccessibilities
      .map(accessibility => accessibility.assignee)
      .forEach(follower => {
        if (follower?.user_name) {
          followerList.push({
            assignee_type: ASSIGNEE_TYPE.USER,
            full_name: follower.name_uppercase,
            id: follower.user_name,
            image_id: null,
            permission: ASSIGNEE_TYPE.USER,
          })
        }
      })

    if (followerList.length > 0) {
      selectPeopleStore.setSelectUserData({
        ...selectUserData,
        USER: followerList,
      })
    }
  }, [documentAccessibilityStore.documentAccessibilities])

  useEffect(() => {
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.USER],
      ...selectDepartmentData[ASSIGNEE_TYPE.USER],
      ...selectGroupData[ASSIGNEE_TYPE.USER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  const onChangeAccessType = value => {
    setAccessType(value)
  }

  const onFinish = async values => {
    try {
      await documentAccessibilityStore.updateDocumentAccessibilities({
        type: 'WORKS',
        access_type: values.accessType,
        username_list: followerList.map(follow => follow.id),
      })
      message.success('Cập nhật quyền thao tác thành công!')
    } catch (error) {
      message.error(error.vi)
      console.log(error)
    }
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>Quyền xem công việc | Xem toàn bộ công việc</title>
      </Helmet>
      <PageTitle location={props.location} />
      <ContentBlockWrapper>
        <Form
          style={{
            paddingLeft: '16px',
          }}
          onFinish={onFinish}
          scrollToFirstError={true}
          name={'document-accessbilities'}
          layout={'vertical'}
          form={form}>
          <p>
            Quyền được cấp chỉ có tác dụng với dữ liệu tính từ thời điểm cấu
            hình được áp dụng trở về sau
          </p>

          <Form.Item
            style={formItemStyle}
            label="Quyền xem toàn bộ công việc"
            name="accessType"
            allowClear
            rules={[
              {
                required: true,
                message: 'Vui lòng chọn quyền!',
              },
            ]}>
            <Select
              placeholder="Chọn quyền xem toàn bộ công việc"
              onChange={onChangeAccessType}
              allowClear>
              <Select.Option value={DOCUMENT_ACCESS_TYPE.VIEW_ALL}>
                Xem toàn bộ
              </Select.Option>
            </Select>
          </Form.Item>
          <div>
            <label style={labelStyle}>Người được cấp quyền:</label>

            <Space>
              <Tooltip title="Chọn người dùng" color={blue}>
                <Button
                  icon={<UserOutlined style={{ color: blue }} />}
                  onClick={() =>
                    handleOpenSelectUserDepartmentPopup(ASSIGNEE_TYPE.USER)
                  }
                />
              </Tooltip>
            </Space>

            {followerList.length > 0 && (
              <SelectList style={{ maxHeight: 'unset' }}>
                {followerList
                  .filter(el => el.id !== 'admin_vpdt')
                  .map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
              </SelectList>
            )}
          </div>

          <FormButtonGroup>
            <Button type={'primary'} htmlType={'submit'}>
              Lưu
            </Button>
          </FormButtonGroup>

          <SelectPeoplePopup
            disableSelectDepartment
            handleCancelSelectUser={handleCancelSelectUserDepartment}
            handleSubmitSelectUser={() =>
              setIsVisibleSelectUserDepartmentPopup(false)
            }
            isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
          />
        </Form>
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

export default inject(
  'selectUserStore',
  'documentAccessibilityStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore'
)(observer(RiskManagement))
